import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'

export default class IVWTracking {
  config (config) {
    if (!config) { return }

    config['sv'] = this.surveyOption(config.sv)
    config['st'] = this.mediaQuery()

    return config
  }

  surveyOption (currentSetting) {
    if (currentSetting === 'ke') { return 'ke' }

    return MediaQuery.current === 'small' ? 'mo' : 'in'
  }

  mediaQuery () {
    if (MediaQuery.current === 'small') {
      return 'mobzeit'
    } else {
      return 'zeitonl'
    }
  }
}

export const bind = () => {
  MediaQuery._init()

  return new IVWTracking()
}

global.IVWTracking = bind()
